export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}user/auth`;

    return $resource(url, null, {
        authenticateWithEmail: {
            method: 'POST',
            url: `${url}/login`
        },
        links: {
            method: 'GET',
            url: `${url}/links`,
            isArray: true
        },
        renewToken: {
            method: 'POST',
            url: `${url}/renew-token`
        },
        selectSite: {
            method: 'POST',
            url: `${url}/select-site`
        },
        requestTacToken: {
            method: 'POST',
            url: `${url}/request-tac-token`
        },
        shortToken: {
            method: 'GET',
            url: `${url}/short-token`
        },
        samlLogin: {
            method: 'GET',
            url: `${url}/saml-login-url`
        },
        samlProfile: {
            method: 'GET',
            url: `${url}/saml-profile-url`
        },
        loginSaml: {
            method: 'POST',
            url: `${url}/login-saml`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Auth/index.js